var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_429_3305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H100V100H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_429_3305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6145 96.3984C62.434 92.7375 61.8822 87.4119 59.4062 82.9957",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1913 77.9049C51.7606 74.5068 51.1378 69.5664 51.0758 66.8902C51.0575 66.0938 50.1325 65.6527 49.5048 66.1432C41.5924 72.3258 41.3614 81.9824 41.3614 81.9824C40.4725 81.3629 39.8923 80.4668 39.5192 79.643C39.1821 78.8988 38.1231 78.893 37.7592 79.6246C33.529 88.1301 35.9083 94.2371 36.9901 96.2861",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6152 88.1505C24.0064 82.3597 26.2833 75.2837 28.9038 70.4063C30.9966 66.5159 33.3425 62.5556 33.9865 58.2312C34.1011 57.4618 35.0251 57.1345 35.6056 57.6522C36.8441 58.7562 37.7277 60.3464 38.1343 61.7188C46.4281 58.0499 49.5306 44.8655 49.8806 38.554C49.9259 37.737 50.8989 37.3433 51.5101 37.8878C59.0261 44.5833 63.8023 54.4038 63.8023 66.129C63.8023 66.1954 63.8023 66.2638 63.8003 66.3321C63.7222 71.6681 65.5835 76.8204 68.8357 81.0528C69.7456 82.2384 70.5779 83.6446 71.1753 85.2872C71.5632 86.3546 71.8454 87.3493 72.0341 88.2798",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8025 15.2812C53.1986 7.7587 47.1691 3.66397 43.6035 1.71026C42.2486 0.967678 40.6092 2.00616 40.6848 3.54932C41.3477 17.0757 37.8166 28.7439 34.327 36.7573C32.491 32.4427 29.5025 28.2456 24.2525 26.1282C22.8635 25.5681 21.3631 26.6933 21.5342 28.1812C22.1131 33.2204 21.7494 38.3677 20.4549 43.2724C19.5281 46.7841 15.8451 51.4519 15.1758 61.8491",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2344 68.4897C16.8937 85.3568 31.1184 98.5352 48.4219 98.5352C66.8408 98.5352 81.7723 83.6037 81.7723 65.1848C81.7723 62.6084 81.4891 60.2904 81.1277 58.382C80.8039 56.6707 78.5746 56.1764 77.5744 57.6024C75.2971 60.8496 72.1764 62.2455 72.1764 62.2455C72.1764 43.5693 67.8893 30.2445 62.4668 20.857",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.025 45.4072C78.6273 45.4072 78.3047 45.0848 78.3047 44.6869V40.9871C78.3047 37.7258 80.9486 35.082 84.21 35.082C84.6078 35.082 84.9301 35.4043 84.9301 35.8021V39.5021C84.9301 42.7633 82.2863 45.4072 79.025 45.4072Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7059 18.4482C30.1037 18.4482 30.4262 18.1258 30.4262 17.7279V14.0281C30.4262 10.7668 27.7822 8.12305 24.5209 8.12305C24.1232 8.12305 23.8008 8.44531 23.8008 8.84317V12.5432C23.8008 15.8043 26.4445 18.4482 29.7059 18.4482Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP3);
export default __webpack_public_path__ + "static/media/p3.70a27582c2491e9702a79837f30ee336.svg";
export { ForwardRef as ReactComponent };